var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useBadgingTranslation } from '../../../../ui/hooks';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { organizationEntityName } from '@juvare/contact-management/backend/features/organizations/shared';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
export function useAccountBadgeOrganizationsValueProvider() {
    const { t } = useBadgingTranslation();
    const accountStorage = new StorageClient(accountEntityName);
    const organizationStorage = new StorageClient(organizationEntityName);
    return {
        type: 'accountOrganizations',
        label: t(`badges.accountOrganizations`),
        getValues: (accountId) => __awaiter(this, void 0, void 0, function* () {
            const account = yield accountStorage.get(accountId);
            const accountOrganizationIds = Object.keys(account.data.orgRole);
            const organizations = yield organizationStorage.list({
                filter: [
                    {
                        id: accountOrganizationIds,
                        op: 'in',
                    },
                ],
            });
            return organizations.rows.map(({ id, columns }) => ({
                label: columns.name,
                value: id,
            }));
        }),
    };
}
